"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _fingerprintjs = _interopRequireDefault(require("fingerprintjs2"));

var _cookieNames = require("../constants/cookieNames");

var _appsflyerStatus = require("../constants/appsflyerStatus");

var Cookie = function Cookie(_domain) {
  var _this = this;

  (0, _classCallCheck2["default"])(this, Cookie);
  (0, _defineProperty2["default"])(this, "COOKIE_DOMAIN", void 0);
  (0, _defineProperty2["default"])(this, "getSecureStringInHttps", function () {
    if (document.location.protocol === 'https:') {
      return 'SameSite=None; Secure;';
    }

    return '';
  });
  (0, _defineProperty2["default"])(this, "setCookie", function (name, value) {
    var expireDay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 90;
    var d = new Date();
    d.setTime(d.getTime() + expireDay * 864e5);
    var expires = "expires= ".concat(d.toUTCString());
    var domain = "domain=".concat(_this.COOKIE_DOMAIN);
    document.cookie = "".concat(name, "=").concat(value, ";").concat(expires, ";").concat(domain, ";path=/;").concat(_this.getSecureStringInHttps());
  });
  (0, _defineProperty2["default"])(this, "deleteCookie", function (name) {
    var expires = 'expires= Thu, 01 Jan 1970 00:00:00 UTC';
    var domain = "domain=".concat(_this.COOKIE_DOMAIN);
    document.cookie = "".concat(name, "=;").concat(expires, ";").concat(domain, ";path=/;").concat(_this.getSecureStringInHttps());
  });
  (0, _defineProperty2["default"])(this, "readCookie", function (name) {
    var nameEQ = "".concat(name, "=");
    var ca = document.cookie.split(';');

    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];

      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length);
      }

      if (c.indexOf(nameEQ) === 0) {
        var value = decodeURIComponent(c.substring(nameEQ.length, c.length));
        return value && value !== 'undefined' ? value : null;
      }
    }

    return null;
  });
  (0, _defineProperty2["default"])(this, "saveCookieFromAuthInfo", function (_ref) {
    var userId = _ref.userId,
        userExternalId = _ref.userExternalId,
        username = _ref.username,
        firstName = _ref.firstName,
        lastName = _ref.lastName,
        role = _ref.role,
        email = _ref.email,
        avatar = _ref.avatar,
        countryCode = _ref.countryCode,
        region = _ref.region,
        phone = _ref.phone,
        loginType = _ref.loginType;

    _this.setCookie(_cookieNames.USER_DATA, JSON.stringify({
      userId: userId,
      userExternalId: userExternalId,
      username: encodeURIComponent(username),
      avatar: avatar,
      role: role,
      email: email,
      countryCode: countryCode,
      firstName: firstName ? encodeURIComponent(firstName) : '',
      lastName: lastName ? encodeURIComponent(lastName) : '',
      region: region,
      loginType: loginType,
      phone: phone
    }));
  });
  (0, _defineProperty2["default"])(this, "updateUserToken", function (token) {
    _this.setCookie(_cookieNames.TOKEN, token);
  });
  (0, _defineProperty2["default"])(this, "deleteAuthCookie", function () {
    _this.deleteCookie(_cookieNames.TOKEN);

    _this.deleteCookie(_cookieNames.USER_DATA);
  });
  (0, _defineProperty2["default"])(this, "generateAndSetDeviceId", function () {
    if (_this.readCookie(_cookieNames.DEVICE_ID)) {
      return;
    }

    new _fingerprintjs["default"]().get(function (hash) {
      _this.setCookie(_cookieNames.DEVICE_ID, hash);
    });
  });
  (0, _defineProperty2["default"])(this, "getAppsFlyerConversionData", function () {
    // collect conversion data
    var pid = _this.readCookie(_cookieNames.APPSFLYER_PID);

    var c = _this.readCookie(_cookieNames.APPSFLYER_C);

    var afAdsetId = _this.readCookie(_cookieNames.APPSFLYER_ADSET_ID);

    var afId = _this.readCookie(_cookieNames.APPSFLYER_ID);

    return {
      media_source: pid,
      campaign: c,
      af_status: pid ? _appsflyerStatus.NonOrganic : _appsflyerStatus.Organic,
      af_adset_id: afAdsetId,
      af_id: afId
    };
  });
  this.COOKIE_DOMAIN = _domain;
} // not need `secure` in http enviorment
;

var _default = Cookie;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@snapask/common-components/dist/utils/cookie.js
// module id = 51
// module chunks = 33